/* Ardor Printing - designer "talk to us" callout (CC-CORE, Oct 16, 2026; v1.1.0 phone bar rule, same day).
   Shared by the designer pages. Rendered through snippets/ardor-contact-callout.liquid, which prints the top bar and a
   JSON config (script[data-acc-config]). This file adds: the order-panel button (re-placed whenever the designer
   re-renders), the phone sticky bar (narrow screens only; hidden whenever the order-panel row - or the designer bar that
   holds it - is on screen, because that row is then the phone callout; never over the designer's own bars; dismissible),
   and the pop-up that embeds the SAME HubSpot form as /pages/contact (portal 44709798, form
   030a6598-6cec-49ae-bf26-571a6f6e27e1, region na2), loaded on first open. The form itself is never changed; only fields
   that already exist on it are pre-filled. dataLayer events: ardor_contact_callout_click, ardor_contact_call_click,
   ardor_contact_form_open, ardor_contact_form_submitted. */
(function () {
  'use strict';
  var W = window, D = document;
  if (W.ArdorContactCallout && W.ArdorContactCallout.version) return;

  var PORTAL = '44709798', FORM_ID = '030a6598-6cec-49ae-bf26-571a6f6e27e1', REGION = 'na2';
  var EMBED_SRC = 'https://js-na2.hsforms.net/forms/embed/' + PORTAL + '.js';
  var NARROW_PX = 767;
  var HYST_PX = 24;       /* to SHOW the phone bar, the panel row's bar must be at least this far off screen */
  var SHOW_DELAY = 220;   /* ... and stay off screen this long (ms): the bar never toggles on consecutive frames */
  var STORE_KEY = 'ardorContactStickyHidden';
  var DEFAULT_BARS = '.abx-foot,.abb-mbar,[data-acc-bar]';

  var cfg = null, topEl = null, panelEl = null, stickyEl = null, modal = null, box = null, formHost = null;
  var loadEl = null, failEl = null, observer = null, observed = null;
  var lastPlacement = 'top', opener = null, isOpen = false, formReady = false, loadTimer = 0, pollTimer = 0;
  var prefillDone = false, dismissed = false, inputFocused = false, rafId = 0, scanAt = 0, scanTimer = 0;
  var autoBars = [], fixedEls = [], submitted = {}, savedPad = null, offSince = 0, laterT = 0, toggles = 0;

  var ICON_CHAT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 5h16v11H9l-5 4z"/><path d="M8 9.5h8M8 12.5h5"/></svg>';
  var ICON_PHONE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.4 1.8.7 2.7a2 2 0 0 1-.5 2.1L8 9.8a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.6 2.7.7a2 2 0 0 1 1.7 2z"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function qs(sel, ctx) { if (!sel) return null; try { return (ctx || D).querySelector(sel); } catch (e) { return null; } }
  function qsa(sel, ctx) { if (!sel) return []; try { return Array.prototype.slice.call((ctx || D).querySelectorAll(sel)); } catch (e) { return []; } }
  function shown(el) { return !!(el && el.isConnected && el.getClientRects().length); }
  function store(get, val) {
    try {
      if (get) return W.sessionStorage.getItem(STORE_KEY) === '1';
      W.sessionStorage.setItem(STORE_KEY, val ? '1' : '0');
    } catch (e) { /* storage blocked: keep it for this page view only */ }
    return false;
  }

  /* ---------- config ---------- */
  function readConfig() {
    var el = qs('script[data-acc-config]'), c = {};
    if (el) { try { c = JSON.parse(el.textContent || '{}') || {}; } catch (e) { c = {}; } }
    c.product = String(c.product || 'Custom printing');
    c.label = String(c.label || c.product);
    c.tel = String(c.tel || '+14256290796');
    c.telText = String(c.telText || '(425) 629-0796');
    c.panel = String(c.panel || '');
    c.panelPos = /^(after|before|append|prepend)$/.test(c.panelPos) ? c.panelPos : 'after';
    c.view = String(c.view || '');
    c.bar = String(c.bar || '');
    c.fields = [];
    if (c.hsType) c.fields.push(['0-5/request_project_type', String(c.hsType)]);
    String(c.hsMore || '').split(';').forEach(function (pair) {
      var i = pair.indexOf('=');
      if (i < 1) return;
      var k = pair.slice(0, i).trim(), v = pair.slice(i + 1).trim();
      if (!k || !v) return;
      if (k.indexOf('/') < 0) k = '0-5/' + k;
      c.fields.push([k, v]);
    });
    return c;
  }

  /* ---------- tracking ---------- */
  function push(name, extra) {
    var o = { event: name, product: cfg.product };
    if (extra) for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) o[k] = extra[k];
    try { W.dataLayer = W.dataLayer || []; W.dataLayer.push(o); } catch (e) { /* never break the page */ }
  }

  /* ---------- the designer around us ---------- */
  function viewEl() {
    var v = qs(cfg.view);
    if (v) return v;
    var n = topEl;
    while (n && (n = n.nextElementSibling)) { if (!/^(SCRIPT|LINK|STYLE|TEMPLATE)$/.test(n.tagName)) return n; }
    return topEl ? topEl.parentElement : D.body;
  }
  function rootEl() {
    var v = viewEl();
    return (topEl && topEl.parentElement) || (v && v.parentElement) || D.body;
  }

  /* ---------- order-panel button ---------- */
  function buildPanel() {
    var el = D.createElement('div');
    el.className = 'acc acc-panel';
    el.setAttribute('data-acc-panel', '');
    el.innerHTML =
      '<p class="acc-panel__q">Don\'t have artwork? Need to talk to someone?</p>' +
      '<div class="acc-panel__btns">' +
        '<button type="button" class="acc-btn acc-btn--line acc-btn--ink" data-acc-open="panel" aria-haspopup="dialog">' + ICON_CHAT + '<span>Message us</span></button>' +
        '<a class="acc-btn acc-btn--line" href="tel:' + esc(cfg.tel) + '" data-acc-call="panel">' + ICON_PHONE + '<span>Call ' + esc(cfg.telText) + '</span></a>' +
      '</div>';
    return el;
  }
  function pickAnchor() {
    var list = qsa(cfg.panel);
    for (var i = 0; i < list.length; i++) if (!panelEl || !panelEl.contains(list[i])) { if (shown(list[i])) return list[i]; }
    return list[0] || null;
  }
  function placePanel() {
    if (!cfg.panel) return;
    var a = pickAnchor();
    if (!a) return;
    if (!panelEl) panelEl = buildPanel();
    var pos = cfg.panelPos, ok;
    if (pos === 'after') ok = a.nextElementSibling === panelEl;
    else if (pos === 'before') ok = a.previousElementSibling === panelEl;
    else if (pos === 'append') ok = panelEl.parentNode === a && a.lastElementChild === panelEl;
    else ok = panelEl.parentNode === a && a.firstElementChild === panelEl;
    if (ok) return;
    if (pos === 'after') a.parentNode.insertBefore(panelEl, a.nextSibling);
    else if (pos === 'before') a.parentNode.insertBefore(panelEl, a);
    else if (pos === 'append') a.appendChild(panelEl);
    else a.insertBefore(panelEl, a.firstChild);
  }

  /* ---------- phone sticky bar ---------- */
  function buildSticky() {
    var el = D.createElement('div');
    el.className = 'acc acc-sticky';
    el.setAttribute('data-acc-sticky', '');
    el.setAttribute('role', 'complementary');
    el.setAttribute('aria-label', 'Talk to Ardor Printing');
    el.hidden = true;
    el.innerHTML =
      '<p class="acc-sticky__txt">Don\'t have artwork?</p>' +
      '<button type="button" class="acc-btn acc-btn--red" data-acc-open="sticky" aria-haspopup="dialog">' + ICON_CHAT + '<span>Message us</span></button>' +
      '<a class="acc-btn acc-btn--line" href="tel:' + esc(cfg.tel) + '" data-acc-call="sticky" aria-label="Call ' + esc(cfg.telText) + '">' + ICON_PHONE + '<span>Call</span></a>' +
      '<button type="button" class="acc-sticky__x" data-acc-dismiss aria-label="Hide this bar">' + ICON_X + '</button>';
    D.body.appendChild(el);
    return el;
  }
  function isNarrow() {
    var mq = false;
    try { mq = W.matchMedia('(max-width: ' + NARROW_PX + 'px)').matches; } catch (e) { mq = W.innerWidth <= NARROW_PX; }
    var v = viewEl(), w = v ? v.getBoundingClientRect().width : 0;
    return mq || (w > 0 && w <= NARROW_PX);
  }
  /* Elements in the designer that are fixed / sticky to the bottom (the designer's own total + Add to cart bar) and
     big fixed layers (drawers, bottom sheets). Scanned at most every 1.5 s, only on narrow screens. */
  function scan(force) {
    var now = Date.now();
    if (!force && now - scanAt < 1500) return;
    scanAt = now;
    autoBars = []; fixedEls = [];
    var r = rootEl();
    if (!r) return;
    var all = r.getElementsByTagName('*'), n = Math.min(all.length, 6000);
    for (var i = 0; i < n; i++) {
      var el = all[i];
      if (el === stickyEl || (panelEl && panelEl.contains(el)) || el.namespaceURI !== 'http://www.w3.org/1999/xhtml') continue;
      var cs = W.getComputedStyle(el), p = cs.position;
      if (p !== 'fixed' && p !== 'sticky') continue;
      if (p === 'fixed') fixedEls.push(el);
      if (cs.bottom === '0px') autoBars.push(el);
    }
  }
  function bars() {
    var list = qsa((cfg.bar ? cfg.bar + ',' : '') + DEFAULT_BARS).concat(autoBars), out = [];
    for (var i = 0; i < list.length; i++) if (out.indexOf(list[i]) < 0 && list[i] !== stickyEl) out.push(list[i]);
    return out;
  }
  function overlayOpen(vh) {
    if (qs('dialog[open]')) return true;
    for (var i = 0; i < fixedEls.length; i++) {
      var el = fixedEls[i];
      if (!shown(el)) continue;
      var r = el.getBoundingClientRect();
      if (r.height > vh * 0.45 && r.top < vh - 40 && r.bottom > 40 && r.width > 120) return true;
    }
    return false;
  }
  /* The element that carries the order-panel row on screen: its nearest fixed / sticky ancestor inside the section
     (the designer's own bottom bar, e.g. .abx-foot or .wss__footer), else the row itself. */
  function homeEl() {
    if (!panelEl || !panelEl.isConnected) return null;
    var r = rootEl(), el = panelEl.parentElement;
    while (el && el !== D.body && el !== D.documentElement) {
      var p = W.getComputedStyle(el).position;
      if (p === 'sticky' || p === 'fixed') return el;
      if (el === r) break;
      el = el.parentElement;
    }
    return panelEl;
  }
  /* bottom offset so the phone bar sits above every designer bar in the band it would cover (never on top of one) */
  function stackOffset(vh) {
    var H = stickyEl.offsetHeight || 56, off = 0, bl = bars(), changed = true, guard = 0;
    while (changed && guard++ < 5) {
      changed = false;
      for (var i = 0; i < bl.length; i++) {
        if (!shown(bl[i])) continue;
        var r = bl[i].getBoundingClientRect();
        if (r.height <= 0 || r.height >= vh * 0.45 || r.top >= vh || r.bottom <= 0) continue;
        if (r.bottom > vh - off - H && r.top < vh - off) {
          var need = Math.ceil(vh - r.top);
          if (need > off) { off = need; changed = true; }
        }
      }
    }
    return off;
  }
  function later(ms) {
    if (laterT) return;
    laterT = W.setTimeout(function () { laterT = 0; layout(); }, Math.max(16, ms));
  }
  function layout() {
    rafId = 0;
    placePanel();
    if (!stickyEl) return;
    if (panelEl) panelEl.classList.remove('is-merged');
    var vh = W.innerHeight, want = false, now = Date.now(), off = 0;
    if (isNarrow() && !dismissed && !isOpen && !inputFocused) {
      scan(false);
      var v = viewEl(), vr = v ? v.getBoundingClientRect() : null;
      var inView = !!(vr && vr.height && vr.top < vh - 120 && vr.bottom > 160);
      var topR = topEl ? topEl.getBoundingClientRect() : null;
      var topVisible = !!(topR && topR.height && topR.bottom > 0 && topR.top < vh);
      var h = homeEl(), homeOff = true;
      if (h && shown(h)) {
        var hr = h.getBoundingClientRect(), m = stickyEl.hidden ? HYST_PX : 0;
        homeOff = hr.top >= vh + m || hr.bottom <= -m;
      }
      want = inView && !topVisible && homeOff && !overlayOpen(vh);
      if (want) {
        off = stackOffset(vh);
        if (off > vh * 0.5) want = false;
      }
    }
    if (!want) offSince = 0;
    else if (stickyEl.hidden) {
      if (!offSince) offSince = now;
      if (now - offSince < SHOW_DELAY) { want = false; later(SHOW_DELAY - (now - offSince) + 10); }
    }
    stickyEl.style.bottom = (want ? off : 0) + 'px';
    stickyEl.classList.toggle('is-stacked', want && off > 0);
    if (stickyEl.hidden === want) { stickyEl.hidden = !want; toggles++; }
  }
  function schedule() { if (!rafId) rafId = (W.requestAnimationFrame || W.setTimeout)(layout); }
  function rescanSoon() {
    if (scanTimer) return;
    scanTimer = W.setTimeout(function () { scanTimer = 0; if (isNarrow()) { scan(true); schedule(); } }, 400);
  }

  /* ---------- pop-up ---------- */
  function buildModal() {
    if (modal) return;
    modal = D.createElement('div');
    modal.className = 'acc acc-modal';
    modal.hidden = true;
    modal.innerHTML =
      '<div class="acc-modal__scrim" data-acc-close></div>' +
      '<div class="acc-modal__box" role="dialog" aria-modal="true" aria-labelledby="acc-modal-title" aria-describedby="acc-modal-sub" tabindex="-1">' +
        '<div class="acc-modal__head">' +
          '<div class="acc-modal__hd">' +
            '<h2 class="acc-modal__title" id="acc-modal-title">Send us a message</h2>' +
            '<p class="acc-modal__sub" id="acc-modal-sub">About your ' + esc(cfg.label) + '. Our team will help. Prefer to talk? ' +
              '<a href="tel:' + esc(cfg.tel) + '" data-acc-call="popup">Call ' + esc(cfg.telText) + '</a></p>' +
          '</div>' +
          '<button type="button" class="acc-modal__x" data-acc-close aria-label="Close">' + ICON_X + '</button>' +
        '</div>' +
        '<div class="acc-modal__body">' +
          '<p class="acc-modal__load" data-acc-load role="status">Loading the form&hellip;</p>' +
          '<p class="acc-modal__fail" data-acc-fail hidden>The form did not load. Call us at ' +
            '<a href="tel:' + esc(cfg.tel) + '" data-acc-call="popup">' + esc(cfg.telText) + '</a> or use our <a href="/pages/contact">contact page</a>.</p>' +
          '<div class="acc-modal__form" data-acc-form></div>' +
        '</div>' +
      '</div>';
    D.body.appendChild(modal);
    box = modal.querySelector('.acc-modal__box');
    formHost = modal.querySelector('[data-acc-form]');
    loadEl = modal.querySelector('[data-acc-load]');
    failEl = modal.querySelector('[data-acc-fail]');
  }
  function focusables() {
    if (!box) return [];
    return qsa('a[href],button:not([disabled]),iframe,input,select,textarea,[tabindex]:not([tabindex="-1"])', box)
      .filter(function (el) { return shown(el); });
  }
  function lockScroll(on) {
    var h = D.documentElement, b = D.body;
    if (on) {
      var sw = W.innerWidth - h.clientWidth;
      savedPad = b.style.paddingRight;
      if (sw > 0) b.style.paddingRight = sw + 'px';
      h.classList.add('acc-lock', 'acc-open');
    } else {
      h.classList.remove('acc-lock', 'acc-open');
      b.style.paddingRight = savedPad || '';
      savedPad = null;
    }
  }
  function open(placement, from) {
    buildModal();
    if (isOpen) return;
    lastPlacement = placement || 'top';
    opener = from || D.activeElement;
    modal.hidden = false;
    isOpen = true;
    lockScroll(true);
    try { box.focus({ preventScroll: true }); } catch (e) { box.focus(); }
    ensureForm();
    push('ardor_contact_form_open', { placement: lastPlacement });
    schedule();
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    modal.hidden = true;
    lockScroll(false);
    var o = opener; opener = null;
    if (o && o.isConnected && typeof o.focus === 'function') { try { o.focus({ preventScroll: true }); } catch (e) { o.focus(); } }
    schedule();
  }

  /* ---------- HubSpot form (same embed as /pages/contact, loaded on first open) ---------- */
  function ensureForm() {
    if (formHost.getAttribute('data-acc-started')) return;
    formHost.setAttribute('data-acc-started', '1');
    var fr = D.createElement('div');
    fr.className = 'hs-form-frame';
    fr.setAttribute('data-region', REGION);
    fr.setAttribute('data-form-id', FORM_ID);
    fr.setAttribute('data-portal-id', PORTAL);
    formHost.appendChild(fr);
    if (!qs('script[src*="hsforms.net/forms/embed/' + PORTAL + '.js"]')) {
      var s = D.createElement('script');
      s.src = EMBED_SRC;
      s.defer = true;
      s.setAttribute('data-acc-embed', '');
      D.head.appendChild(s);
    }
    loadTimer = W.setTimeout(function () { if (!formReady) { loadEl.hidden = true; failEl.hidden = false; } }, 20000);
    /* fallback only: the form's own on-ready event normally arrives first */
    W.setTimeout(function () { if (!formReady) pollTimer = W.setInterval(pollReady, 700); }, 5000);
  }
  function ourInstance() {
    var f = formHost && formHost.querySelector('iframe');
    if (!f || !f.src) return null;
    try { return new URL(f.src, W.location.href).searchParams.get('_hsInstanceId'); } catch (e) { return null; }
  }
  function ourForm() {
    var mine = ourInstance(), list = [];
    try { list = (W.HubSpotFormsV4 && W.HubSpotFormsV4.getForms()) || []; } catch (e) { list = []; }
    for (var i = 0; i < list.length; i++) {
      try { if (mine && list[i].getInstanceId() === mine) return list[i]; } catch (e) { /* skip */ }
    }
    return null;
  }
  function eventIsOurs(e) {
    if (!formHost || !formHost.getAttribute('data-acc-started')) return false;
    var d = (e && e.detail) || {}, mine = ourInstance();
    if (mine && d.instanceId && d.instanceId === mine) return true;
    var f = null;
    try { f = W.HubSpotFormsV4 && W.HubSpotFormsV4.getFormFromEvent(e); } catch (x) { f = null; }
    if (f && mine) { try { if (f.getInstanceId() === mine) return true; } catch (x) { /* fall through */ } }
    /* same form id and ours is the only frame of that form on the page */
    var fid = d.formId || (f && f.getFormId ? f.getFormId() : '');
    return fid === FORM_ID && qsa('.hs-form-frame[data-form-id="' + FORM_ID + '"]').length === 1;
  }
  function markReady(f) {
    if (formReady) return;
    formReady = true;
    W.clearTimeout(loadTimer); W.clearInterval(pollTimer);
    loadEl.hidden = true; failEl.hidden = true;
    if (f) prefill(f);
  }
  function pollReady() {
    var ifr = formHost && formHost.querySelector('iframe');
    if (ifr && W.HubSpotFormsV4) {
      var f = ourForm();
      if (f) {
        /* a form object exists: wait a moment for the frame to finish, then treat it as ready */
        W.setTimeout(function () { markReady(f); }, 1200);
        W.clearInterval(pollTimer);
      }
    }
  }
  function prefill(f) {
    if (prefillDone || !cfg.fields.length) return;
    prefillDone = true;
    Promise.resolve().then(function () { return f.getFormFieldValues(); }).then(function (vals) {
      var have = {};
      (vals || []).forEach(function (v) { if (v && v.name) have[v.name] = v.value; });
      var todo = cfg.fields.filter(function (p) {
        if (!Object.prototype.hasOwnProperty.call(have, p[0])) return false;      /* only fields the form already has */
        var cur = have[p[0]];
        return cur == null || cur === '' || (Array.isArray(cur) && !cur.length);  /* never overwrite an answer */
      });
      var i = 0;
      (function next() {
        if (i >= todo.length) return;
        var p = todo[i++];
        try { f.setFieldValue(p[0], p[1]); } catch (e) { /* field refused the value: leave it */ }
        W.setTimeout(next, 350); /* let the form's conditional questions appear before the next field */
      })();
    }).catch(function () { /* leave the form as it is */ });
  }

  /* ---------- events ---------- */
  function onClick(e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var o = t.closest('[data-acc-open]');
    if (o) {
      var pl = o.getAttribute('data-acc-open') || 'top';
      push('ardor_contact_callout_click', { placement: pl });
      /* a link with ctrl / cmd / shift / middle click keeps its normal job (contact page in a new tab) */
      if (o.tagName === 'A' && (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1)) return;
      e.preventDefault();
      open(pl, o);
      return;
    }
    var c = t.closest('[data-acc-call]');
    if (c) { push('ardor_contact_call_click', { placement: c.getAttribute('data-acc-call') || 'top' }); return; }
    if (t.closest('[data-acc-close]') && modal && modal.contains(t)) { e.preventDefault(); close(); return; }
    if (t.closest('[data-acc-dismiss]')) {
      e.preventDefault();
      dismissed = true; store(false, true);
      if (panelEl) panelEl.classList.remove('is-merged');
      schedule();
    }
  }
  function onKey(e) {
    if (!isOpen) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopPropagation(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) { e.preventDefault(); box.focus(); return; }
    var first = f[0], last = f[f.length - 1], a = D.activeElement;
    if (e.shiftKey && (a === first || a === box)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
    else if (!box.contains(a)) { e.preventDefault(); first.focus(); }
  }
  function onFocusIn(e) {
    var t = e.target;
    if (isOpen) {
      /* keep focus in the pop-up; iframes outside it (e.g. a reCAPTCHA check) are left alone */
      if (t && t !== D && t !== W && !modal.contains(t) && t.tagName !== 'IFRAME') {
        var f = focusables();
        (f[0] || box).focus();
      }
      return;
    }
    var typing = !!(t && t.closest && !t.closest('.acc') &&
      (/^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName) || t.isContentEditable) &&
      !/^(button|submit|checkbox|radio|range|color|file|reset|image)$/i.test(t.type || ''));
    if (typing !== inputFocused) { inputFocused = typing; schedule(); }
  }
  function onFocusOut() { if (inputFocused) { inputFocused = false; W.setTimeout(schedule, 60); } }
  function onReady(e) {
    if (!eventIsOurs(e)) return;
    var f = null;
    try { f = W.HubSpotFormsV4.getFormFromEvent(e); } catch (x) { f = null; }
    markReady(f || ourForm());
  }
  function onSubmitted(e) {
    if (!eventIsOurs(e)) return;
    var id = ((e && e.detail) || {}).instanceId || ourInstance() || 'acc';
    if (submitted[id]) return;
    submitted[id] = true;
    push('ardor_contact_form_submitted', { placement: lastPlacement, form_id: FORM_ID });
  }

  function observe() {
    var r = rootEl();
    if (!r || r === observed || !W.MutationObserver) return;
    if (observer) observer.disconnect();
    observer = new W.MutationObserver(function () { schedule(); rescanSoon(); });
    observer.observe(r, { childList: true, subtree: true });
    observed = r;
  }

  function init() {
    cfg = readConfig();
    topEl = qs('[data-acc-top]');
    dismissed = store(true);
    stickyEl = buildSticky();
    D.addEventListener('click', onClick);
    D.addEventListener('keydown', onKey, true);
    D.addEventListener('focusin', onFocusIn);
    D.addEventListener('focusout', onFocusOut);
    W.addEventListener('scroll', schedule, { passive: true });
    W.addEventListener('resize', function () { schedule(); rescanSoon(); });
    W.addEventListener('orientationchange', function () { schedule(); rescanSoon(); });
    W.addEventListener('hs-form-event:on-ready', onReady);
    W.addEventListener('hs-form-event:on-submission:success', onSubmitted);
    observe();
    placePanel();
    if (isNarrow()) scan(true);
    schedule();
    /* designers build their layout after load: try again a few times */
    [300, 1000, 2500, 5000].forEach(function (ms) { W.setTimeout(function () { observe(); schedule(); rescanSoon(); }, ms); });
  }

  W.ArdorContactCallout = {
    version: '1.1.0',
    open: function (placement) { open(placement || 'api', null); },
    close: close,
    refresh: function () { scan(true); if (rafId) { (W.cancelAnimationFrame || W.clearTimeout)(rafId); } layout(); },
    config: function () { return cfg; },
    state: function () {
      return { open: isOpen, formReady: formReady, instance: ourInstance(), dismissed: dismissed,
        stickyShown: !!(stickyEl && !stickyEl.hidden), stickyBottom: stickyEl ? stickyEl.style.bottom : '',
        panelPlaced: !!(panelEl && panelEl.isConnected), merged: false, toggles: toggles,
        home: (function () { var h = homeEl(); return h ? (h === panelEl ? 'row' : (h.className || h.tagName).toString().split(' ')[0]) : null; })() };
    }
  };

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init);
  else init();
})();
